const waterRouter = [
    {
        path: "list-water",
        name: "water",
        component: () => import("@/views/admin/water"),
        default: true,
        meta: {
            model: "water_parameters",
            requiresAuth: true,
        },
    },
    {
        path: "list-water/add",
        name: "addWater",
        component: () => import("@/views/admin/water/function"),
        default: true,
        meta: {
            model: "water_parameters",
            requiresAuth: true,
        },
    },
    {
        path: "list-water/edit/:id",
        name: "editWater",
        component: () => import("@/views/admin/water/function"),
        default: true,
        meta: {
            model: "water_parameters",
            requiresAuth: true,
        },
    },
];
export default waterRouter;